import PeriodicalEvaluation from './PeriodicalEvaluation';

export default PeriodicalEvaluation;
